import * as error from "./api/error";

export enum Keys {
    DSN = "dsn",
    GoogleClickId = "gclid",
    CardBrand = "cardbrand",
    InstantCard = "instantCard",
}

export enum Values {
    PalExpired = "PAL-EXPIRED",
    PalForgot = "PAL-FORGOT",
    PalUnknown = "PAL-UNKNOWN",
}

function isStringKey(key: string | number): key is string {
    return typeof key === "string";
}

export function objectify(query: string): {[key: string]: string} {
    const qs: {[key: string]: string} = {};

    const sliced = /^[?#]/.test(query) ? query.slice(1) : query;
    if (!sliced) {
        return qs;
    }

    return sliced.split("&").reduce((acc: {[key: string]: string}, param) => {
        const [key, value] = param.split("=");
        acc[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
        return acc;
    }, qs);
}

export function stringify(obj: {[key: string]: string}): string {
    const keys: string[] = Object.keys(obj).filter(isStringKey);
    if (keys.length === 0) {
        return "";
    }
    const qs = keys.map((key: string) => `${key}=${obj[key]}`).join("&");
    return `?${qs}`;
}

export function addDSN(current: string, value: string): string {
    const qs = objectify(current);
    qs[Keys.DSN] = value;
    return stringify(qs);
}

function objectifyFullURL(urlString: string): {[key: string]: string} {
    const qs: {[key: string]: string} = {};
    try {
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        params.forEach((value, key) => {
            qs[key] = value;
        });
    } catch (err) {
        error.reportUnknown(err, "queryStringHelpers");
    }
    return qs;
}

export function addReferrerGCLID(current: string, referrer: string): string {
    // NOTE(CK): The following logic includes a temporary work-around for
    // incorrect QS handling in the Google Ad redirect logic. Remove once
    // that issue is resolved.
    const referrerQS = referrer ? objectifyFullURL(referrer) : {};
    const referrerGCLID = referrerQS[Keys.GoogleClickId];

    if (referrerGCLID) {
        const qs = objectify(current);
        qs[Keys.GoogleClickId] = referrerGCLID;
        return stringify(qs);
    }

    return current;
}
